import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ScrollingListProps {
  height: string;
}

const ScrollingList = styled(Stack)(({ height }: ScrollingListProps) => ({
  height: height,
  overflowY: 'auto',
  maxHeight: 'calc(100% - 20px)',
  paddingRight: '10px',
}));

export default ScrollingList;